import { render } from "./PhotoDataTable.vue?vue&type=template&id=1cb8a112&scoped=true"
import script from "./PhotoDataTable.vue?vue&type=script&lang=js"
export * from "./PhotoDataTable.vue?vue&type=script&lang=js"

import "./PhotoDataTable.vue?vue&type=style&index=0&id=1cb8a112&scoped=true&lang=css"

import exportComponent from "C:\\8 Extension Folder\\8.0 Extension Folder\\8.02\\SMMPortfolioSite\\photographydays-login\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb8a112"]])

export default __exports__